import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {instantiateSwitchery, setSwitchery} from '../../utilities/instantiateSwitchery';
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';

const elementsMap = {
  sharePrimarySwitch: '.switch-share-primary',
  prefix: '.ret-prefix',
  firstName: '.ret-first-name',
  lastName: '.ret-last-name',
  email: '.ret-email',
  addMobileBtn: '.add-mobile-number-btn',
  removeMobileBtn: '.remove-mobile-btn',
  addressSection: '.address-section',
  contactSection: '.contact-section',
  phoneSection: '.phone-section'
};

const addressElementsMap = {
  country: '.ret-country',
  address1: '.ret-address1',
  address2: '.ret-address2',
  city: '.ret-city',
  state: '.ret-state',
  zipCode: '.ret-zip-code',
  postalCodeLabel:'#postalcode-label',
  stateLabel:'#state-label',
  county: '.ret-county',
  countyMandatoryLabel: '.county-mandatory-label',
  stateSelectContainer: '.state-wrapper',
  stateTextContainer: '.state-text-wrapper',
  stateTextInput: '.ret-state-text',
  commercialAddressFlag: '.commercial-addr-flag'
};

const phoneElementsMap = {
  officeCountryCodeBill: '.ret-office-country-code-bill',
  officePhoneBill: '.ret-office-phone-bill',
  officeAreaCodeBill: '.ret-office-area-code-bill',
  mobileCountryCodeBill: '.ret-mobile-country-code-bill',
  mobilePhoneBill: '.ret-mobile-phone-bill',
  mobileAreaCodeBill: '.ret-mobile-area-code-bill',
  mobilePhoneSection: '.ret-mobile-number-section',
  officeExt: '.ret-office-ext',
  officeCountryCode: '.ret-office-country-code',
  officePhone: '.ret-office-phone',
  officeAreaCode: '.ret-office-area-code',
  mobileCountryCode: '.ret-mobile-country-code',
  mobilePhone: '.ret-mobile-phone',
  mobileAreaCode: '.ret-mobile-area-code',
};

export default function BillingTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const primaryEls = {};
  const retailerWizard = $('#retailer-wizard');
  const validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));
  const billingTab = wizardElement.find('.billing-information-tab');
  const primaryTab = wizardElement.find('.primary-information-tab');
  const defaultContry = wizardElement.data('default-country');
  const usaStates = wizardElement.data('usa-states');
  const caProvinces = wizardElement.data('ca-provinces');
  const countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
  const countries = wizardElement.data('countries');
  const prefixes = wizardElement.data('prefixes');
  const retailerJsonString = wizardElement.data('retailer-obj');
  const rtlType = wizardElement.data('rtl-type');
  const elementSelector = "input, select";
  let isDataModified = false;
  let countryId;
  

  self.init = function(){
    render();
  };

  function render(){
    setElements();
    setUniqNamesAndIds(els); // jquery validator needs that all "name" attribute are unique
    loadDropDowns();
    setStates(defaultContry);
    els.country.on("change", countryChange); // due to an issue in country triggering, moving it up
    renderViewWithData();
    bindElements();
 }

  function setElements(){
    setElementsFromScope(els, addressElementsMap, billingTab);
    setElementsFromScope(els, elementsMap, billingTab);
    setElementsFromScope(els, phoneElementsMap, billingTab);

    setElementsFromScope(primaryEls, addressElementsMap, primaryTab);
    setElementsFromScope(primaryEls, elementsMap, primaryTab);
    setElementsFromScope(primaryEls, phoneElementsMap, primaryTab);
  }

  function bindElements() {
    els.officeCountryCodeBill.on("change",officeCountryCodeChange);
    els.mobileCountryCodeBill.on("change",mobileCountryCodeChange);
    $(document).on("click", '.billing-information-tab .add-mobile-number-btn', handleAddMobileBtn);
    $(document).on("click", '.billing-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
      // for share primary address switch
    $('.billing-information-tab .switch-share-primary').on("change", handleSharePrimarySwitch);
    // To check if some information is modified. require to replace primary info if user modified something on tab
    _.map(billingTab.find($(elementSelector)), function(element){
      if(!$(element).is(":checkbox")){
        $(element).on("change", handleInputChange);
      }
    });
  }

  function loadDropDowns() {
    $(countries).each(function(){
      var option = $('<option />');
      option.attr('value', this.conCode).text(this.conName);
      els.country.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.officeCountryCodeBill.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.mobileCountryCodeBill.append(option);
    });

    $(prefixes).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.prefix.append(option);
    });
  }

  function setStates(countryVal) {
    els.state.html('');
    var option = $('<option />');
    option.attr('value', "-1").text('Select State/Province/Region');
    option.attr('selected','selected');
    option.attr('disabled','disabled');
    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });

    if(countryVal == "US" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.show();

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.addClass("zipcodeUS");
      els.zipCode.prop('required',true);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      els.state.append(option);
      $(usaStates).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else if(countryVal == "CA" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.hide();

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.removeClass("zipcodeUS");
      els.zipCode.prop('required',true);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      els.state.append(option);
      $(caProvinces).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else {
      if(checkZipCode){
        els.stateLabel.text('State/Province/Region');
        els.postalCodeLabel.text('Postal Code *');
        els.state.prop('required',false);
        els.stateTextInput.prop('required',false);
        els.zipCode.removeClass("zipcodeUS");
        els.zipCode.prop('required',true);
        //els.zipCode.valid();
  
        //els.countyMandatoryLabel.hide();
        hide(els.stateSelectContainer);
        show(els.stateTextContainer);
      }else{
        els.stateLabel.text('State/Province/Region');
        els.postalCodeLabel.text('Postal Code');
        els.state.prop('required',false);
        els.stateTextInput.prop('required',false);
        els.zipCode.removeClass("zipcodeUS");
        els.zipCode.prop('required',false);
        els.zipCode.valid();
  
        //els.countyMandatoryLabel.hide();
        hide(els.stateSelectContainer);
        show(els.stateTextContainer);
      }
      
    }
  }

  function renderViewWithData() {
    const retailer = getRetailer();
    if(_.isObject(retailer)) { // During edit, pre populate data
       setSwithcery(els.sharePrimarySwitch, retailer.rtlBillAccEqPrimary);
       if(retailer.rtlBillAccEqPrimary) { // If billing tab shared from primary
          hideAllSections();
       } else {
          showAllSections();
       }
        let billingAddress = getBillingAddress(retailer);
        if(_.isObject(billingAddress)) {
          setData(billingAddress);
        } else {
          hide(els.mobilePhoneSection); // blank form shown with no mobile section
        }
    } else { // New retailer
      hide(els.mobilePhoneSection); // Not shown on initial load while creating new
      setSwithcery(els.sharePrimarySwitch, true);
      // since be default, share primary is Yes, hide all sections
      hideAllSections();
    }
  }

  function setData(billingAddress) {
    els.country.val(billingAddress.cadCountry).trigger("change");
    els.address1.val(billingAddress.cadAddress1);
    els.address2.val(billingAddress.cadAddress2);
    els.city.val(billingAddress.cadCity);

    if(billingAddress.cadCountry != "US" && billingAddress.cadCountry != "CA") { // Set state text input
      els.stateTextInput.val(billingAddress.cadState);
    } else {
      els.state.val(billingAddress.cadState).trigger("change");
    }

    els.zipCode.val(billingAddress.cadZipcode);
    els.county.val(billingAddress.cadCounty);

    els.prefix.val(billingAddress.cadContactNamePrefix).trigger("change");
    els.firstName.val(billingAddress.cadContactName);
    els.lastName.val(billingAddress.cadContactLastName);
    els.email.val(billingAddress.cadContactEmail);

    els.officeCountryCodeBill.val(billingAddress.cadOfficePhoneCountryCode).trigger("change");
    els.officePhoneBill.val(billingAddress.cadOfficePhone);
    
    if(els.officeAreaCodeBill){
      els.officeAreaCodeBill.val(billingAddress.cadOfficePhoneAreaCode);
      els.officeAreaCodeBill.addClass('phoneNonUS');
    }  
    // start
    if(billingAddress.cadOfficePhoneAreaCode==='+1'){
      
      els.officePhoneBill.attr("placeholder", "___-____");
      els.officePhoneBill.addClass('ret-phone-number-jqv');
      els.officePhoneBill.removeClass('phoneNonUS'); 
      els.officePhoneBill.val(billingAddress.cadOfficePhone);  
      
      els.cadOfficePhoneAreaCode.removeClass('phoneNonUS');
      els.cadOfficePhoneAreaCode.val(billingAddress.cadOfficePhoneAreaCode); 

      addmasks();  

    }else{
      els.officePhoneBill.addClass('phoneNonUS');
      els.officePhoneBill.removeClass('ret-phone-number-jqv');
      els.officePhoneBill.removeAttr('placeholder');
      els.officePhoneBill.inputmask({mask: ""});     

      //cadOfficePhoneAreaCode validation start
      
      if(els.officeAreaCodeBill){
        els.officeAreaCodeBill.addClass('phoneNonUS');
        els.officeAreaCodeBill.removeAttr('placeholder');
        els.officeAreaCodeBill.inputmask({mask: ""});
      }

      if(billingAddress.cadOfficePhoneAreaCode){
        let val= billingAddress.cadOfficePhoneAreaCode;
        const v=val.replace(/[^0-9.]/g, "");
        billingAddress.cadOfficePhoneAreaCode=v;
        els.officeAreaCodeBill.val(v);
      }
      //cadOfficePhoneAreaCode validation end

      //cadOfficePhone validation start
      if(billingAddress.cadOfficePhone){
        let val= billingAddress.cadOfficePhone;
        const v=val.replace(/[^0-9.]/g, "");
        billingAddress.cadOfficePhone=v;
        els.officePhoneBill.val(v);
      }  
      if(els.officeAreaCodeBill){
          hide(els.officeAreaCodeBill);
      }
      //cadOfficePhone validation end
    }
    // End

    els.officeExt.val(billingAddress.cadOfficePhoneExt);

    if(!isMobileInformationPresent(billingAddress)) {
      els.mobileCountryCodeBill.val(billingAddress.cadMobilePhoneCountryCode).trigger("change");
      
      
      if(billingAddress.cadMobilePhoneCountryCode==='+1'){
        
        els.mobilePhoneBill.removeClass('phoneNonUS');         
        if(els.mobileAreaCodeBill){
          els.mobileAreaCodeBill.removeClass('phoneNonUS');
        }
        els.mobilePhoneBill.addClass('ret-phone-number-jqv');
        els.mobilePhoneBill.attr("placeholder", "___-____");
        addMasksMobilePhone();
        els.mobilePhoneBill.val(billingAddress.cadMobilePhone);  
        
        if(billingAddress.cadMobilePhoneAreaCode !=null){
          els.mobileAreaCodeBill.val(billingAddress.cadMobilePhoneAreaCode);
        }else{
          hide(els.mobileAreaCodeBill);
        } 
          
      }else{

        /* Start Phone number changes */
        els.mobilePhoneBill.addClass('phoneNonUS');
        els.mobilePhoneBill.removeClass('ret-phone-number-jqv');
        els.mobilePhoneBill.removeAttr('placeholder');
        els.mobilePhoneBill.inputmask({mask: ""}); 

        if(billingAddress.cadMobilePhone){
          let val= billingAddress.cadMobilePhone;
          const v=val.replace(/[^0-9.]/g, "");
          billingAddress.cadMobilePhone=v;
          els.mobilePhoneBill.val(v);
        }  
        /* End Phone number changes */

        /* Start Mobile code number changes */
        if(els.mobileAreaCodeBill){
          els.mobileAreaCodeBill.inputmask({mask: ""});
          els.mobileAreaCodeBill.addClass('phoneNonUS');
          els.mobileAreaCodeBill.removeAttr('placeholder');
        }
        
        if(billingAddress.cadMobilePhoneAreaCode){
          let val= billingAddress.cadMobilePhoneAreaCode;
          const v=val.replace(/[^0-9.]/g, "");
          billingAddress.cadMobilePhoneAreaCode=v;
          els.mobileAreaCodeBill.val(v);   
          $('.ret-mobile-area-code-bill').val(v);
        }
        
        hide(els.mobileAreaCodeBill);

      }
      
      els.mobilePhoneBill.val(billingAddress.cadMobilePhone);
      if(billingAddress.cadMobilePhoneAreaCode !==null){
      els.mobileAreaCodeBill.val(billingAddress.cadMobilePhoneAreaCode);
      }else{
        hide(els.mobileAreaCodeBill);
      }
      hide(els.addMobileBtn);
    } else {
      hide(els.mobilePhoneSection);
      show(els.addMobileBtn);
    }
  }

  function setPrimaryInfoData() {
    els.country.val(primaryEls.country.val()).trigger("change");
    els.address1.val(primaryEls.address1.val());
    els.address2.val(primaryEls.address2.val());
    els.city.val(primaryEls.city.val());

    if(primaryEls.country.val() != "US" && primaryEls.country.val() != "CA") { // Set state text input
      els.stateTextInput.val(primaryEls.stateTextInput.val());
    } else {
      els.state.val(primaryEls.state.val()).trigger("change");
    }

    els.zipCode.val(primaryEls.zipCode.val());
    els.county.val(primaryEls.county.val());

    els.prefix.val(primaryEls.prefix.val()).trigger("change");
    els.firstName.val(primaryEls.firstName.val());
    els.lastName.val(primaryEls.lastName.val());
    els.email.val(primaryEls.email.val());

    els.officeCountryCodeBill.val(primaryEls.officeCountryCode.val()).trigger("change");
    els.officePhoneBill.val(primaryEls.officePhone.val());
    els.officeAreaCodeBill.val(primaryEls.officeAreaCode.val());
    els.officeExt.val(primaryEls.officeExt.val());

    if(primaryEls.mobilePhoneSection.is(":visible")) {
      show(els.mobilePhoneSection);
      els.mobileCountryCodeBill.val(primaryEls.mobileCountryCode.val()).trigger("change");
      els.mobilePhoneBill.val(primaryEls.mobilePhone.val());
      els.mobileAreaCodeBill.val(primaryEls.mobileAreaCode.val());
      hide(els.addMobileBtn);
    } else {
      hide(els.mobilePhoneSection);
      show(els.addMobileBtn);
    }
  }

  function setSwithcery(checkbox, bool) {
    instantiateSwitchery(checkbox);
    setSwitchery(checkbox, bool);
  }

  function handleAddMobileBtn() {
    show(els.mobilePhoneSection);
    hide(els.addMobileBtn);
  }

  function handleRemoveMobileBtn() {
    hide(els.mobilePhoneSection);
    show(els.addMobileBtn);
    els.mobileCountryCodeBill.val('');
    els.mobilePhoneBill.val('');      
    els.mobileAreaCodeBill.val('');   
    
    const retailer = getRetailer();
    if(_.isObject(retailer)) {
      let billingAddress = getBillingAddress(retailer);
      billingAddress.cadMobilePhoneCountryCode='';
      billingAddress.cadMobilePhone='';
      billingAddress.cadMobilePhoneAreaCode='';  
    }
  }

  function isMobileInformationPresent(billingAddress) {
    return isBlank(billingAddress.cadMobilePhoneCountryCode)
      && isBlank(billingAddress.cadMobilePhone)
      && isBlank(billingAddress.cadMobilePhoneAreaCode);
  }

  function handleSharePrimarySwitch() {
    if(isWizardOnBillingTab()) {
      if(this.checked) {
        hideAllSections();
      } else {
        showAllSections();
        if(!isEdit() && !isDataModified) {
          setPrimaryInfoData();
        }
      }
    }
  }

  function handleInputChange(e) {
    e.preventDefault();
    if(isWizardOnBillingTab() && !self.isPrimarySwitchOn()) {
      isDataModified = true;
    }
  }

  function isWizardOnBillingTab() {
    return $(wizard.getActiveTargetForm()).filter(".billing-information-tab").length > 0;
  }

  self.isPrimarySwitchOn = function() {
    return $('.billing-information-tab .switch-share-primary').is(":checked");
  }

  function showAllSections() {
      show(els.addressSection);
      show(els.contactSection);
      show(els.phoneSection);
  }

  function hideAllSections() {
      hide(els.addressSection);
      hide(els.contactSection);
      hide(els.phoneSection);
  }

  function countryChange() {
    let countryVal = els.country.find('option:selected').val();
    let isValidCountry = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
        countryId = this.conPhoneCode.toString();
        return false;
      } 
    });
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryVal.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country_not_supported_billing").hide();        
    }else{
      $(".country_not_supported_billing").show();
    }
    setStates(countryVal);if(countryVal === "US"){
      $(".ret-office-country-code-bill option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States of America +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "CA"){
      $(".ret-office-country-code-bill option").filter(function() {
        let text= $(this).text().toString();
        return text === "Canada +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "UM"){
      $(".ret-office-country-code-bill option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States Minor Outlying Islands +1";
    }).prop("selected", true).trigger("change");
    }else{
      $(".ret-office-country-code-bill option").filter(function() {
        let text= $(this).val().toString();
        return text === countryId.toString();
    }).prop("selected", true).trigger("change");
      //$(".ret-office-country-code option:contains("+countryId+")").attr('selected', 'selected').trigger("change");
    }
    if(countryVal === "US" || countryVal === "CA" ){
      show(els.officeAreaCodeBill);
      els.officePhoneBill.attr("placeholder", "___-____");
      els.officePhoneBill.addClass('ret-phone-number-jqv');
      els.officePhoneBill.removeClass('phoneNonUS');
      addmasks();
    }else {
      els.officeAreaCodeBill.val('');
      if(els.officeAreaCodeBill){
        hide(els.officeAreaCodeBill);
      }
      els.officePhoneBill.val('');
      els.officePhoneBill.addClass('phoneNonUS');
      els.officePhoneBill.removeClass('ret-phone-number-jqv');
      els.officePhoneBill.removeAttr('placeholder'); 
      els.officePhoneBill.inputmask({
        mask: ""
      });
      
    }
  }

  function addmasks(){
    $('.ret-office-area-code-bill').inputmask({
      mask: "(999)"
    });

    $('.ret-office-phone-bill').inputmask({
      mask: "999-9999"
    });
  }

  function addMasksMobilePhone(){
    $('.ret-mobile-area-code-bill').inputmask({
      mask: "(999)"
    });

    $('.ret-mobile-phone-bill').inputmask({
      mask: "999-9999"
    });
  }

  function mobileCountryCodeChange(){
    let mobilecode  = els.mobileCountryCodeBill.find('option:selected').val().toString();
    els.mobilePhoneBill.val('');
    if(els.mobileAreaCodeBill){
      els.mobileAreaCodeBill.val('');
    }
    if( mobilecode === '+1'){
      show(els.mobileAreaCodeBill);
      els.mobilePhoneBill.attr("placeholder", "___-____");
      els.mobilePhoneBill.addClass('ret-phone-number-jqv');
      els.mobilePhoneBill.removeClass('phoneNonUS');
      if(els.mobileAreaCodeBill){
        els.mobileAreaCodeBill.removeClass('phoneNonUS');
      }
      addMasksMobilePhone();
  }else{      
      hide(els.mobileAreaCodeBill);
      els.mobilePhoneBill.addClass('phoneNonUS');
      els.mobilePhoneBill.removeClass('ret-phone-number-jqv');
      els.mobilePhoneBill.removeAttr('placeholder');
      els.mobilePhoneBill.inputmask({mask: ""});
    }
  }

  function officeCountryCodeChange(){
    let phoneCode = els.officeCountryCodeBill.find('option:selected').val().toString();
    els.officePhoneBill.val('');
    if(els.officeAreaCodeBill){
      els.officeAreaCodeBill.val('');
    }
    if( phoneCode === '+1'){
      show(els.officeAreaCodeBill);
      els.officePhoneBill.attr("placeholder", "___-____");
      els.officePhoneBill.addClass('ret-phone-number-jqv');
      els.officePhoneBill.removeClass('phoneNonUS');
      if(els.officeAreaCodeBill){
        els.officeAreaCodeBill.removeClass('phoneNonUS');
      }
      addmasks();
    }else{      
      hide(els.officeAreaCodeBill);
      els.officePhoneBill.addClass('phoneNonUS');
      els.officePhoneBill.removeClass('ret-phone-number-jqv');
      els.officePhoneBill.removeAttr('placeholder'); 
      els.officePhoneBill.inputmask({
        mask: ""
      });
    }
  }

  function getRetailer() {
    if(!isBlank(retailerJsonString)) {
      return retailerJsonString;
    } else {
      return null;
    }
  }

  function getBillingAddress(retailer) {
    let billingAddress = _(retailer.retailerAddresses).find((address, k)=>{
      return address.cadAddressType == "Billing";
    });

    return billingAddress;
  }

  function existingRetailerHasBillingAddress() {
    return isEdit() && _.isObject(getBillingAddress(getRetailer()));
  }

  function isEdit() {
    return _.isObject(getRetailer());
  }
}



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/BillingTab.js